export default "__VITE_ASSET__glBa5HcE__"